import { Skeleton } from "@/components/ui/skeleton";

interface OnboardingSkeletonProps {
  count?: number;
  columns?: number;
}

export function OnboardingSkeleton({ count = 6, columns = 3 }: OnboardingSkeletonProps) {
  const colsClass =
    columns === 5
      ? "grid-cols-2 sm:grid-cols-3 md:grid-cols-5"
      : columns === 6
        ? "grid-cols-2 sm:grid-cols-3 md:grid-cols-6"
        : "grid-cols-2 sm:grid-cols-3";

  return (
    <div className={`grid ${colsClass} gap-4 sm:gap-5`} aria-label="loading onboarding grid" role="status">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-border-primary bg-bg-secondary p-4 animate-pulse">
          <Skeleton className="aspect-square w-full rounded-xl" />
          <Skeleton className="mt-3 h-3 w-2/3" />
          <Skeleton className="mt-2 h-3 w-1/2" />
        </div>
      ))}
    </div>
  );
}